import React, { useEffect, useState } from 'react';
import './results-container.styles.scss';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import arrow from '@/assets/left-arrow.png';
import { properCase } from '@/utils/properCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import ImageContainer from '../image-container/image-container.component';
import { RandomString } from '@/utils/randomString';
import { format } from 'date-fns';
import ItemViewModal from './item-view-modal.component';
import { useSelector } from 'react-redux';

const ResultsContainer = ({
    contentToShow,
    path,
    cat,
    setCat,
    dir,
    setDir,
    searchText,
    element,
    chooseElement
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ categories, setCategories ] = useState(null);
    const [ directories, setDirectories ] = useState(null);
    // const [ resHeight, setResHeight ] = useState(0);
    const [ dirImages ] = useState({
        'Images': '/images/icons/image.png',
        'Badges': '/images/icons/badges.png',
        'Items': '/images/icons/items.png',
        'Templates': '/images/icons/board-game.png',
    })
    const [ itemToView, setItemToView ] = useState(null);
    const [ allowed, setAllowed ] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const containerEl = document.getElementsByClassName('results-container')[0];
        if (containerEl) {
            // const containerHeight = containerEl.offsetHeight;
            // setResHeight(containerHeight - 52);
        }
    }, [])

    useEffect(() => {
        if (!element) return;
        if (element === 'gameHeader' || element === 'itemIcon') {
            setAllowed(['uncroppedImage', 'croppedImage'])
        } else if (element.toLowerCase().includes('icon')) {
            setAllowed(['croppedImage'])
        } else {
            setAllowed([element])
        }
    }, [element])

    useEffect(() => {
        if (!contentToShow) return;
        let cats = [...new Set(contentToShow.map(c => c.cat))];
        setCategories(cats);
        let dirs = [];
        for (let c of contentToShow) {
            if (c.dir && c.dir.length > 0) {
                dirs = [...dirs, ...c.dir];
            }
        }
        const set = [...new Set(dirs)];
        let dirArr = []
        set.map(d => {
            const items = contentToShow
            .sort((a,b) => a.data.name.toLowerCase() > b.data.name.toLowerCase() ? 1 : -1)
            .filter(i => i.dir.includes(d));
            dirArr.push({
                'name': d,
                'id': RandomString(18),
                'url': items[0].data.url ?? items[0].data.icon
            })
        })
        setDirectories(dirArr);
        
    }, [contentToShow])

    function breadcrumbNav(e, level) {
        if (e === 'categories') {
            setCat(null);
            setDir(null);
        } else {
            setDir(e);
        }
    }

    return (
        <div className={`g-list-item results-container ${screenSize}`}>
            {
                (screenSize === 'mobile' && path) &&
                <><h3>
                    {
                        path === 'free'
                        ?
                        'Free Content'
                        :
                        path === 'uploads'
                        ?
                        'My Content'
                        :
                        'My Purchases'
                    }
                </h3>
                <hr />
                </>
            }
            {
                (path && categories && directories) &&
                <>
                <div className={`breadcrumbs meta ${screenSize}`}>
                    <div className='crumb'>
                        <button 
                            className='g-button text-only inline'
                            onClick={() => breadcrumbNav('categories')}>
                            Categories
                        </button>
                        <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                    {
                        (cat) &&
                        <div className='crumb'>
                        <button 
                            className='g-button text-only inline'
                            onClick={() => breadcrumbNav(null)}>
                            {cat}
                        </button>
                        <FontAwesomeIcon icon={faCaretRight} />
                        </div>
                    }
                    {
                        (dir) &&
                        <button className='g-button text-only inline'>
                            {dir}
                        </button>
                    }
                </div>
                <div className="g-space-1"></div>
                </>  
            }
            {
                (!path) &&
                <div className='no-category'>
                    <img src={arrow} className='arrow-icon' />
                    <h3>Choose a Category</h3>
                </div>
            }
            {
                (path && contentToShow && contentToShow.length === 0) &&
                <p className='disabled'>No content yet...</p>
            }
            {
                (categories && !cat && !searchText) &&
                <div 
                    className={`directory-list ${screenSize}`} 
                    // style={{'height': resHeight+'px'}}
                    >
                    {
                        categories.sort()
                        .map(c => {
                            return (
                                <button 
                                    key={c}
                                    className='g-button directory-item'
                                    onClick={() => setCat(c)}>
                                <div className='icon'>
                                    <ImageContainer src={dirImages[c]} />
                                </div>
                                {properCase(c)}
                                </button>
                            )
                        })
                    }
                </div>
            }
            {
                (directories && cat && !dir && !searchText) &&
                <div 
                    className={`directory-list ${screenSize}`} 
                    // style={{'height': resHeight+'px'}}
                    >
                    {
                        directories.sort()
                        .map(d => {
                            return (
                                <button 
                                    key={d.id}
                                    className='g-button directory-item'
                                    onClick={() => setDir(d.name)}>
                                <div className='icon'>
                                    <ImageContainer src={d.url ?? d.icon} />
                                </div>
                                {d.name}
                                </button>
                            )
                        })
                    }
                </div>
            }
            {
                (contentToShow && dir && !searchText) &&
                <div 
                    className='directory-item-list' 
                    // style={{'height': resHeight+'px'}}
                    >
                    {
                        Object.values(contentToShow)
                        .filter(c => c.dir.includes(dir))
                        .sort((a,b) => a.data.name.toLowerCase() > b.data.name.toLowerCase() ? 1 : -1)
                        .map(c => {
                            let dataType;
                            if (c.type === 'image') {
                                if (c.cropped) {
                                    dataType = 'croppedImage'
                                } else {
                                    dataType = 'uncroppedImage'
                                }
                            } else {
                                dataType = c.type;
                            }
                            return (
                                <div 
                                    key={c.id}
                                    className='directory-list-item' >
                                    <div className='item-icon'>
                                        <ImageContainer src={c.data.url ?? c.data.icon} />
                                    </div>
                                    <div title={c.data.name}>
                                        {
                                            c.data.name.length > 20
                                            ?
                                            c.data.name.substring(0, 20) + '...'
                                            :
                                            c.data.name
                                        }
                                    </div>
                                    {
                                        (screenSize === 'mobile') 
                                        ?
                                        <>
                                            <div></div>
                                            <div></div>
                                        </>
                                        :
                                        <>
                                        <div>
                                            {
                                                (c.ts && !c.free)
                                                ?
                                                <span className='meta'>Added {format(new Date(c.ts), "P")}</span>
                                                :
                                                ''
                                            }
                                        </div>
                                        {
                                            
                                        }
                                        <div className='meta'>{properCase(c.type)}</div>
                                        </>
                                    }
                                    <div className='buttons'>
                                        <button 
                                            className='g-button small-btn'
                                            onClick={() => setItemToView(c)} >
                                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                                        </button>
                                        {
                                            (allowed.includes(dataType)) &&
                                            <button 
                                                className='g-button small-btn'
                                                onClick={() => chooseElement(c.data)}>
                                                Select
                                            </button>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }
            {
                (contentToShow && searchText) &&
                <div 
                    className='directory-item-list' 
                    // style={{'height': resHeight+'px'}}
                    >
                    {
                        Object.values(contentToShow)
                        .filter(c => c.data.name.toLowerCase().includes(searchText))
                        .sort((a,b) => a.data.name.toLowerCase() > b.data.name.toLowerCase() ? 1 : -1)
                        .map(c => {
                            console.log(c);
                            let dataType;
                            if (c.type === 'image') {
                                if (c.cropped) {
                                    dataType = 'croppedImage'
                                } else {
                                    dataType = 'uncroppedImage'
                                }
                            } else {
                                dataType = c.type;
                            }
                            return (
                                <div 
                                    key={c.id}
                                    className='directory-list-item' >
                                    <div className='item-icon'>
                                        <ImageContainer src={c.data.url ?? c.data.icon} />
                                    </div>
                                    <div title={c.data.name}>
                                        {
                                            c.data.name.length > 20
                                            ?
                                            c.data.name.substring(0, 20) + '...'
                                            :
                                            c.data.name
                                        }
                                    </div>
                                    <div>
                                        {
                                            (c.ts && !c.free) &&
                                            <span className='meta'>Added {format(new Date(c.ts), "P")}</span>
                                        }
                                    </div>
                                    <div className='meta'>{properCase(c.type)}</div>
                                    <div className='buttons'>
                                        <button 
                                            className='g-button small-btn'
                                            onClick={() => setItemToView(c)} >
                                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                                        </button>
                                        {
                                            (allowed.includes(dataType)) &&
                                            <button 
                                                className='g-button small-btn'
                                                onClick={() => chooseElement(c.data)}>
                                                Select
                                            </button>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }
            <ItemViewModal
                item={itemToView}
                cancel={() => setItemToView(null)} />
        </div>
    )
}

export default ResultsContainer